var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"type__wrap"},[(_vm.title)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"type__title"},'div',attrs,false),on),[_vm._v(_vm._s(_vm.title))])]}}],null,false,1039927014)},[_c('div',[_vm._v(_vm._s(_vm.tooltip))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }